module.exports = __webpack_public_path__ + "img/labora.1e816917.png";